import Vue from 'vue'
import App from './App.vue'
import router from './router'
import { Button, Icon, Row, Col, Tab, Tabs,Popup,Toast,Notify,DropdownMenu, DropdownItem,Dialog,Field} from "vant"

import("@/assets/style/reset.less")
import 'vant/lib/index.css';
import VueClipBoard from 'vue-clipboard2';
Vue.use(VueClipBoard);
//VueClipboard.config.autoSetContainer = true

Vue.use(Button).use(Icon).use(Row).use(Col).use(Tab).use(Tabs).use(Popup).use(Toast).use(Notify).use(DropdownMenu).use(DropdownItem).use(Dialog).use(Field)

Vue.config.productionTip = false

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
